/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "loading-label": [{
    "type": 0,
    "value": "Cargando"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var esES = Object.assign(TranslationProviderComponent, {
  translations
});

export { esES as e };
//# sourceMappingURL=es-ES-B1oaJo1S.js.map
